export enum PromiseStatus {
  NONE,
  PENDING,
  RESOLVED,
  REJECTED,
}
